import React from 'react'
import { Link } from 'react-router-dom'
import picture1 from "../assets/shop/picture1.png"
import picture2 from "../assets/shop/picture2.png"
import picture3 from "../assets/shop/picture3.png"
import HeaderComponent from './HeaderComponent'
import Newsletter from './Newsletter'

const image = [picture1, picture2, picture3]

const Shop = () => {
  return (
    <>
        <HeaderComponent/>
            <div className="container mx-auto px-6 md:px-16 items-center text-center">
                <h1 className="pt-14 text-4xl md:text-6xl font-bold mb-16 md:mb-28">Shop</h1>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 justify-items-center">
                <div className="flex flex-col items-center gap-3 text-center">
                    <img src={picture1} className="w-64 sm:w-72 h-auto mx-auto" />
                    <h2 className="font-bold text-xl sm:text-2xl">TXA Shirt: #5,000</h2>
                    <Link to="/buy-now" className="text-[#F63A0A] font-bold text-lg">
                        Buy Now
                    </Link>
                </div>

                <div className="flex flex-col items-center gap-3 text-center">
                    <img src={picture2} className="w-64 sm:w-72 h-auto mx-auto" />
                    <h2 className="font-bold text-xl sm:text-2xl">TXA Tote Bag: #3,000</h2>
                    <Link to="/buy-now" className="text-[#F63A0A] font-bold text-lg">
                        Buy Now
                    </Link>
                </div>

                <div className="col-span-1 sm:col-span-2 flex justify-center mt-[-10px] sm:mt-[-30px] mb-10">
                    <div className="flex flex-col items-center gap-3 text-center">
                        <img src={picture3} className="w-72 sm:w-80 h-auto mx-auto" />
                        <h2 className="font-bold text-xl sm:text-2xl">TXA NotePad: #3,000</h2>
                        <Link to="/buy-now" className="text-[#F63A0A] font-bold text-lg">
                        Buy Now
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    </>
  )
}

export default Shop